import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ec7154d2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec7154d2')) {
      api.createRecord('ec7154d2', component.options)
    } else {
      api.reload('ec7154d2', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=ec7154d2", function () {
      api.rerender('ec7154d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/guest/Footer.vue"
export default component.exports